import { render, staticRenderFns } from "./unreviewed.vue?vue&type=template&id=61405c2c&scoped=true&"
import script from "./unreviewed.vue?vue&type=script&lang=js&"
export * from "./unreviewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61405c2c",
  null
  
)

export default component.exports